export default "__VITE_ASSET__16b6fd10__"